'use strict';

import * as angular from 'angular';
import 'angular-resource';
import * as io from 'socket.io-client';
import * as _ from 'lodash';
import IContainer from '../../../server/api/container/container.interface';
const Emitter = require('component-emitter');

export function ContainerFactory($resource: ng.resource.IResourceService, socket, socketFactory, Auth, $cookies, $timeout, $interval, $http, $translate) {
  function transformContainer(container){
    if(container.desktop) {
      container.desktop = convertFromExternalDesktop(container.desktop);
    }else{
      container.desktop = {
        wm: 'floating',
        splitpane: false,
        windowModels: [
          {
            application: 'file-tree',
            title: 'Home',
            model: {
              node: {text: '~', id: '~', children: true, icon: 'jstree-folder'},
            },
            ctrl: {},
          },
          {
            application: 'file-tree',
            model: {
              node: {text: '/', id: '/', children: true, icon: 'jstree-folder'},
            },
            ctrl: {},
          },
        ],
      };
      if(container.types.indexOf('php')>=0){
        container.desktop.windowModels.push({
          application: 'editor',
          model: {
            filename: '/home/ubuntu/public_html/index.php',
          },
          ctrl: {},
        });
        container.desktop.windowModels.push({
          application: 'browser',
          model: {
            url: 'https://localhost/~ubuntu/index.php',
          },
          ctrl: {},
        });
      }
      if(container.types.indexOf('jupyter_notebook')>=0){
        container.desktop.windowModels.push({
          application: 'tty',
          model: {
            command: 'jupyter notebook --NotebookApp.token="" --NotebookApp.allow_remote_access=True --NotebookApp.use_redirect_file=False\n',
          },
          ctrl: {},
        });
      }
      const blogUrls = {
        nodejs: {
          ja: 'https://paiza.hatenablog.com/entry/2018/06/08/paizacloud_nodejs#main',
        },
        rails: {
          ja: 'https://paiza.hatenablog.com/entry/paizacloud_ruby_on_rails/2017/12/14#main',
          en: 'https://engineering.paiza.io/entry/paizacloud_ruby_on_rails#main',
        },
        sinatra: {
          ja: 'https://paiza.hatenablog.com/entry/paizacloud_sinatra/2017/12/19#main',
          en: 'https://engineering.paiza.io/entry/paizacloud_ruby_on_rails#main',
        },
        laravel: {
          ja: 'https://paiza.hatenablog.com/entry/2018/02/16/paizacloud_laravel#main',
          en: 'https://engineering.paiza.io/entry/paizacloud_laravel#main',
        },
        php: {
          ja: 'https://paiza.hatenablog.com/entry/2018/09/25/paizacloud_php#main',
          en: 'https://engineering.paiza.io/entry/paizacloud_php#main',
        },
        django: {
          ja: 'https://paiza.hatenablog.com/entry/2018/02/28/paizacloud_django#main',
          en: 'https://engineering.paiza.io/entry/paizacloud_django#main',
        },
        revel: {
          ja: 'https://paiza.hatenablog.com/entry/2018/03/23/paizacloud_golang_revel#main',
          en: 'https://engineering.paiza.io/entry/paizacloud_golang_revel',
        },
      };
      for(const key in blogUrls){
        if(container.types.indexOf(key)>=0){
          let url;
          if($translate.use() === 'ja'){
            // url = 'http://paiza.hatenablog.com/entry/paizacloud_ruby_on_rails/2017/12/14';
            // url = 'https://proxy-paiza-hatenablog-com.paiza.cloud/entry/paizacloud_ruby_on_rails/2017/12/14#main';
            url = blogUrls[key].ja;
            if(url) {
              url = url.replace(new RegExp('^https?://paiza.hatenablog.com/'), 'https://proxy-paiza-hatenablog-com.paiza.cloud/');
            }
          }else{
            // url = 'http://engineering.paiza.io/entry/paizacloud_ruby_on_rails';
            // url = 'http://proxy-engineering-paiza-io.paiza.cloud/entry/paizacloud_ruby_on_rails#main';
            // url = 'https://proxy-paiza-hatenablog-com.paiza.cloud/entry/paizacloud_ruby_on_rails/2017/12/14#main';
            url = blogUrls[key].en;
            if(url) {
              url = url.replace(new RegExp('^https?://engineering.paiza.io/'), 'https://proxy-engineering-paiza-io.paiza.cloud/');
            }
          }
          if(url) {
            container.desktop.windowModels.push({
              application: 'browser',
              model: {
                url: url,
              },
              ctrl: {},
            });
          }
        }
      }
      if(container.types.indexOf('wordpress')>=0){
        container.desktop.windowModels.push({
          application: 'browser',
          model: {
            // url: 'https://localhost/',
            url: `https://${container.containerHostname}`,
          },
          ctrl: {},
        });
      }


      container.desktop.windowModels.forEach((windowModel) => {windowModel.id = Math.random().toString(36).substr(2);});  // eslint-disable-line newline-per-chained-call
    }

    container.ctrl = {};
    return container;
  }

  function parseResponse(data, header){
    let contentType = header()['content-type'];
    if(contentType && contentType.split(';')[0] === 'application/json'){
      return angular.fromJson(data);
    }else{
      return data;
    }
  }

  function transformResponseItr(isArray, data, header, status){
    if(Math.floor(status / 100) * 100 !== 200){
      return parseResponse(data, header);
    }
    let obj = angular.fromJson(data);
    if(isArray){
      let containers = obj;
      let containerObjs = containers.map((container) => {
        return transformContainer(container);
      });
      return containerObjs;
    }else{
      return transformContainer(obj);
    }
  }

  // Ref: http://corpus.hubwiz.com/2/angularjs/21685104.html
  interface IContainerResource extends ng.resource.IResource<IContainerResource>, IContainer{}
  interface IContainerResourceClass extends ng.resource.IResourceClass<IContainerResource>
  {
    keepalive(IContainerResource): IContainerResource;
  }
  let Container = <IContainerResourceClass> $resource('/api/containers/:id/:controller', {
    id: '@id',
  }, {
    /* Default actions: get/save/query/remove(delete) */
    query: {
      method: 'GET',
      isArray: true,
      transformResponse: transformResponseItr.bind(this, true),
    },
    get: {
      method: 'GET',
      transformResponse: transformResponseItr.bind(this, false),
    },
    keepalive: {
      method: 'GET',
      transformResponse: transformResponseItr.bind(this, false),
      params: {
        controller: 'keepalive',
      },
    },
    save: {
      method: 'POST',
      transformResponse: transformResponseItr.bind(this, false),
    },
  });

  function convertFromExternalWindowModel(windowModel){
    let application = windowModel.application;
    if(application === 'finder'){
      windowModel.application = 'file-tree';
      console.log('convertFromExternalWindowModel node=', windowModel.model.node);
    }else if(application === 'terminal'){
      windowModel.application = 'tty';
    }
    windowModel.ctrl = {};
    return windowModel;
  }
  function convertFromExternalWindowModels(srcWindowModels){
    if(srcWindowModels[0] instanceof Array){
      const result = srcWindowModels.map((subWindowModels) => convertFromExternalWindowModels(subWindowModels));
      return result;
    }
    let windowModels = srcWindowModels
      .filter((srcWindowModel) => !!srcWindowModel)
      .map((srcWindowModel, i) => {
        let windowModel = convertFromExternalWindowModel(srcWindowModel);
        windowModel.zIndex = 100 + i;
        windowModel.focused = (i === srcWindowModels.length - 1);
        return windowModel;
      });
    return windowModels;
  }
  function convertFromExternalDesktop(srcDesktop){
    let desktop = {
      wm: srcDesktop.wm,
      splitpane: srcDesktop.splitpane,
      windowModels: convertFromExternalWindowModels(srcDesktop.windowModels),
    };
    if(desktop.splitpane && !(desktop.windowModels && desktop.windowModels[0] instanceof Array)){
      desktop.splitpane = false;
    }
    return desktop;
  }
  class ContainerEx extends Container{
    static transformContainer(container){
      return transformContainer(container);
    }

    socket: any;
    keepaliveTimer?: () => void;
    activeWindow: any;

    disconnectSocket(){
      console.log('Container.prototype.disconnectSocket', this.socket);
      if(this.socket){
        this.socket.disconnect(true);
        delete this.socket;
      }
    }

    setTokenForAgentUrl(bLocalhost: boolean){
      let baseUrl = this.containerAgentUrl;
      if(bLocalhost){
        let parser = document.createElement('a');
        parser.href = this.containerAgentUrl;

        baseUrl = `https://localhost-${this.containerHostname}/__paizacloud_agent__`;
      }
      const setTokenUrl = `${baseUrl}/api/set-token?access_token=${this.containerToken}`;
      return $http.post(setTokenUrl, {}, {
        withCredentials: true,
      })
        .then((r) => {
          console.log('token was set.', r, setTokenUrl);
          if(r.data === 'TOKEN_UPDATED'){
            console.log('TOKEN_UPDATED');
            const emitterEmit = Emitter.prototype.emit;
            emitterEmit.call(this.socket.ioSocket, 'TOKEN_UPDATED');
          }
        })
        .catch((e) => {
          console.log('token set failed', e, setTokenUrl);
        });
    }

    connectSocket(){
      const currentUser = Auth.getCurrentUserSync();

      const socketUrl = this.containerAgentUrl;
      let ioSocket = io(socketUrl, {
        query: {
          token: this.containerToken,
          'user.id': currentUser && currentUser._id,
          'user.name': currentUser && currentUser.name,
          'user.email': currentUser && currentUser.email,
        },
        reconnection: true,
        transports: ["websocket"],
      });

      let containerSocket = socketFactory({
        ioSocket: ioSocket,
      });
      containerSocket.ioSocket = ioSocket;
      this.socket = containerSocket;

      ioSocket.on('connect', (() => {
        console.log("Container:socket.on:connect:", this);
        this.setTokenForAgentUrl(true);
        this.setTokenForAgentUrl(false);
      }));

      this.keepaliveTimer = $interval(() => {
        Container.keepalive({id: this._id, container_token: this.containerToken, updatedBy: socket.ioSocket.id}).$promise
          .then((container) => {
            console.log("/api/containers/keepalive response:", container);
          })
          .catch((response) => {
            console.log("Container not found: response:", response);
          });
      }, 30 * 1000); // 1keepalive / 30sec


      ioSocket.on('disconnect', function(err){
        console.log("Container:socket.on:disconnect:", socketUrl, err);
      });
      ioSocket.on('connect', function(){
        console.log("Container:socket.on:connect:", socketUrl);
      });
      ioSocket.on('reconnect_attempt', function(err){
        /* change Url on renaming container */
        // let socketUrl2 = getSocketUrl();
        (ioSocket.io as any).uri = socketUrl;
        console.log("Container:socket.on:reconnect_attempt:", socketUrl, err);
      });
      ioSocket.on('reconnecting', function(err){
        console.log("Container:socket.on:reconnecting:", socketUrl, err);
      });
      ioSocket.on('reconnect_error', function(err){
        console.error("Container:socket.on:reconnect_error:", socketUrl, err);
      });
      ioSocket.on('reconnect_failed', function(err){
        console.error("Container:socket.on:reconnect_failed:", socketUrl, err);
      });
      ioSocket.on('error', function(err){
        console.error("Container:socket.on:error:", socketUrl, err);
        // window.swal('Error', `Container:connectSocket error: URL=${socketUrl} error=${JSON.stringify(err)}`, 'error');
      });
      ioSocket.on('connect_error', function(err){
        console.error("Container:socket.on:connect_error:", socketUrl, err);
      });
      ioSocket.on('reconnect_error', function(err){
        console.error("Container:socket.on:reconnect_error:", socketUrl, err);
      });
      containerSocket.on('post_message_to_parent', (msg) => {
        console.log('post_message_to_parent', msg);
        if(window.parent) {
          window.parent.postMessage(msg, '*');
        }
      });


    }

    getLastSnapshot(){
      if(this.snapshots.length > 0){
        return this.snapshots[this.snapshots.length - 1];
      }
      return null;
    }

    close(){
      this.disconnectSocket();
      if(this.keepaliveTimer){
        $interval.cancel(this.keepaliveTimer);
        delete this.keepaliveTimer;
      }
    }

    addWindowModel(windowModels, windowModel){
      if(!windowModel.id){
        windowModel.id = Math.random().toString(36).substr(2);  // eslint-disable-line newline-per-chained-call
      }
      if(!windowModel.ctrl){
        windowModel.ctrl = {};
      }
      if(!windowModels){
        if(this.desktop.splitpane){
          windowModels = this.desktop.windowModels[0];
        }else{
          windowModels = this.desktop.windowModels;
        }
      }

      const lastWindowModel:any = _.last(windowModels);
      let zIndex = (lastWindowModel && lastWindowModel.zIndex) ? lastWindowModel.zIndex + 1 : 100;
      windowModel.zIndex = zIndex;
      windowModel.focused = true;
      windowModels.forEach((windowModel) => {windowModel.focused = false;});

      windowModels.push(windowModel);
      this.saveDesktop();
    }

    deleteWindowModel(windowModel){
      if(this.desktop.splitpane){
        this.desktop.windowModels.forEach((windowModels) => {
          _.pull(windowModels, windowModel);
        });
      }else{
        _.pull(this.desktop.windowModels, windowModel);
        let lastWindowModel:any = _.last(this.desktop.windowModels);
        lastWindowModel && lastWindowModel.ctrl && lastWindowModel.ctrl.focus && lastWindowModel.ctrl.focus();
      }
      this.orderAndFocusLast();
      this.saveDesktop();
    }

    activateWindowModel(windowModel){
      this.activeWindow = windowModel;
      this.focusWindowModel(windowModel, true);
    }
    orderAndFocusLast(){
      let orderedWindowModels = [...this.desktop.windowModels];
      orderedWindowModels.reduce((zIndex, cur) => {if(!cur.zIndex){cur.zIndex = zIndex + 0.001;} return cur.zIndex;}, 100);
      orderedWindowModels.sort((a, b) => a.zIndex - b.zIndex);

      orderedWindowModels.forEach((windowModel, i) => {
        windowModel.zIndex = 100 + i;
        windowModel.focused = (i === orderedWindowModels.length - 1);
      });
    }
    getLastWindowModel(){
      let lastWindowModel;
      let zIndex = -10000;
      this.desktop.windowModels.forEach((windowModel) => {
        if(windowModel.zIndex >= zIndex){
          lastWindowModel = windowModel;
          zIndex = windowModel.zIndex;
        }
      });
      return lastWindowModel;
    }
    focusWindowModel(windowModel, bForce){
      console.log('Container.focusWindowModel');

      if(this.desktop.windowModels.indexOf(windowModel) === -1){
        return;
      }

      const lastWindowModel = this.getLastWindowModel();
      if(!bForce && lastWindowModel === windowModel){
        return;
      }

      windowModel.zIndex = 10000;
      this.orderAndFocusLast();

      this.saveDesktop();
      $timeout( () => {
        windowModel.ctrl && windowModel.ctrl.focus && windowModel.ctrl.focus();
      });
    }

    getFile(filename){
      let url = `${this.containerAgentUrl}/api/resource?resource=${encodeURIComponent(filename)}&content_type=text/plain&access_token=${this.containerToken}`;
      return $http.get(url, {transformResponse: undefined });
    }

    writeFile = function(filename, body, options){
      let url = `${this.containerAgentUrl}/api/writeFile?access_token=${this.containerToken}`;

      return $http.post(url, {
        filename: filename,
        data: body,
        options,
      });
    };

    saveDesktop(){
      let desktop = this.exportDesktop();
      console.log('saveDesktop', desktop, this, socket.ioSocket.id);
      return $http.patch(`/api/containers/${this._id}`, {
        desktop: desktop,
        updatedBy: socket.ioSocket.id,
      }, {params: {container_token: this.containerToken}})
        .then((updated) => {
          console.log("Updated:", updated);
        });
    }

    openFile(windowModels, filename, event?){
      const ext = filename.split('.').pop();
      const currentUser = Auth.getCurrentUserSync();
      const matchedApplications = (currentUser.applications || []).filter((application) => ((application.extensions || []).indexOf(ext) >= 0));
      if(matchedApplications.length > 0){
        const application = matchedApplications[0];
        const windowModel = {
          application: 'customapplication',
          model: {
            type: application.type,
            applicationId: application._id,
            url: application.url,
            files: application.files,
            name: application.name,
            filename: filename,
          },
          ctrl: {},
        };
        this.addWindowModel(windowModels, windowModel);
        this.activateWindowModel(windowModel);
        return;
      }
      let ma;
      if((ma=filename.match(/\.(gif|jpg|jpeg|png|mp4|mov)$/i)) || (event && event.shiftKey)){
        const ext = ma[1];
        const extToContentType = {
          'jpg': 'image/jpeg',
          'jpeg': 'image/jpeg',
          'gif': 'image/gif',
          'png': 'image/png',
          'mp4': 'video/mp4',
          'mpg': 'video/mpeg',
          'mpeg': 'video/mpeg',
          'mov': 'video/quicktime',
        };
        const contentType = extToContentType[ext];

        let url = this.containerAgentUrl + '/api/resource?resource=' + encodeURIComponent(filename) + `&content_type=${contentType}&access_token=` + this.containerToken;
        window.open(url);
        return;
      }

      const windowModlesToShow = (this.desktop.windowModels[0] instanceof Array) ? this.desktop.windowModels[0] : this.desktop.windowModels;
      let opened = windowModlesToShow.filter((windowModel) => {
        return (windowModel.application === 'editor' && windowModel.model.filename === filename);
      });
      if(opened.length > 0){
        if(this.desktop.wm !== 'tab'){
          const windowModels2 = windowModlesToShow.filter((windowModel) => {
            return windowModel.model.filename !== filename;
          });
          windowModlesToShow.splice(0);
          windowModlesToShow.push(...windowModels2);
          windowModlesToShow.push(opened[0]);
        }
        this.activateWindowModel(opened[0]);
        return;
      }
      let windowModel = {
        application: 'editor',
        model: {
          filename: filename,
        },
        ctrl: {},
        activated: true,
      };
      this.addWindowModel(windowModels, windowModel);
      this.activateWindowModel(windowModel);

    }

    exportWindowModel(windowModel){
      let application = windowModel.application;
      let model = windowModel.model;
      if(application === 'browser'){
        model = {
          url: model.url,
        };
      }else if(application === 'file-tree'){
        application = 'finder';
        let exportNode = (node) => {
          return {
            text: node.text,
            id: node.id,
            opened: node.opened,
            children: (node.children instanceof Array) ? node.children.map((child) => exportNode(child)) : node.children,
            icon: node.icon,
          };
        };
        model = {
          dir: model.node.id,
          node: exportNode(model.node),
        };
      }else if(application === 'editor'){
        model = {
          filename: model.filename,
          autosave: model.autosave,
        };
      }else if(application === 'tty'){
        application = 'terminal';
      }
      return {
        id: windowModel.id,
        application: application,
        model: model,
      };
    }

    exportWindowModels(srcWindowModels){
      if(srcWindowModels[0] instanceof Array){
        const result = srcWindowModels.map((subWindowModels) => this.exportWindowModels(subWindowModels));
        return result;
      }

      let windowModels = [...srcWindowModels];
      windowModels.reduce((zIndex, cur) => {if(!cur.zIndex){cur.zIndex = zIndex + 0.001;} return cur.zIndex;}, 100);
      windowModels.forEach((windowModel) => {if(windowModel.application==='file-tree'){windowModel.zIndex = 0;}});
      windowModels.sort((a, b) => a.zIndex - b.zIndex);
      windowModels = windowModels.map((windowModel) => this.exportWindowModel(windowModel));
      return windowModels;
    }

    mergeDesktop(externalDesktop)
    {
      console.log('mergeDesktop1', externalDesktop, this);
      if(!externalDesktop) {
        return;
      }
      if(this.splitpane || externalDesktop.splitpane){
        return;
      }
      console.log('mergeDesktop2', externalDesktop, this);
      let externalWindowModelIds = externalDesktop.windowModels.map((windowModel) => windowModel.id);
      let windowModelIds = this.desktop.windowModels.map((windowModel) => windowModel.id);
      this.desktop.windowModels = this.desktop.windowModels.filter((windowModel) => externalWindowModelIds.indexOf(windowModel.id) !== -1);
      let newExternalWindowModels = externalDesktop.windowModels.filter((externalWindowModel) => windowModelIds.indexOf(externalWindowModel.id) === -1);
      newExternalWindowModels = newExternalWindowModels.filter((windowModel) => !(windowModel.application === 'terminal' && !windowModel.model.server));
      let newWindowModels = newExternalWindowModels.map((externalWindowModel) => convertFromExternalWindowModel(externalWindowModel));
      this.desktop.windowModels.push(...newWindowModels);
    }

    merge(externalContainer_){
      let externalContainer = Object.assign({}, externalContainer_);
      let externalDesktop = externalContainer.desktop;
      delete externalContainer.desktop;
      _.merge(this, externalContainer);
      const desktop = convertFromExternalDesktop(externalDesktop);
      this.mergeDesktop(desktop);
    }

    exportDesktop(){
      let desktop = {
        wm: this.desktop.wm,
        splitpane: this.desktop.splitpane,
        windowModels: this.exportWindowModels(this.desktop.windowModels),
      };
      return desktop;
    }

    importDesktop(srcDesktop){
      this.desktop = convertFromExternalDesktop(srcDesktop);
    }
  }

  // Resource Instance created by the Resource class created by $resource is not extendable.
  // http://qiita.com/izumin5210/items/03e6ba29fce0b42af0af
  Object.assign(Container.prototype, ...Object.getOwnPropertyNames(ContainerEx.prototype).map((name) =>({[name]: ContainerEx.prototype[name]})));

  return ContainerEx;
}

export let ContainerFactoryReturn = true ? undefined : ContainerFactory(<ng.resource.IResourceService>{},null,null,null,null,null,null,null,null);
export let ContainerFactoryReturnInstance = ContainerFactoryReturn && new ContainerFactoryReturn();
export type IContainerResourceClass = typeof ContainerFactoryReturn;
export type IContainerResource = typeof ContainerFactoryReturnInstance;

export default angular.module('paizacloudApp.container', [])
  .factory('Container', ContainerFactory)
  .name;
